
import { useLanguage } from "@/hooks/useLanguage";
import { useDashboardData } from "@/hooks/useDashboardData";
import { DashboardError } from "./DashboardError";
import { DashboardCards } from "./DashboardCards";

interface DashboardGridProps {
  days: number;
}

export default function DashboardGrid({ days }: DashboardGridProps) {
  const { t } = useLanguage();
  const {
    data,
    isLoading,
    error,
    isError,
    refetch,
    isRefetching,
  } = useDashboardData(days);

  if (isError && error) {
    return (
      <DashboardError
        error={error}
        refetch={refetch}
        isRefetching={isRefetching}
      />
    );
  }

  return <DashboardCards data={data} isLoading={isLoading} days={days} />;
}
